
import BaseModal from '@marketplace/components/BaseModal.vue'
import LanguagePicker from '@marketplace/components/forms/picker/language-picker.vue'

export default {
    components: {
        BaseModal,
        LanguagePicker,
    },
}
